// Profile4Personal.js

import {
    axios,
    useImperativeHandle, forwardRef, useRef, useContext, useState, useEffect,
    useSelector, useDispatch,
    useLocation, useNavigate, Link,
    AppTheme,
    mui, reducer, component, useShared,  
    replaceTabVerseListNewItem, setRead, getYearOfBirthList, localizedDateTime, verseRangeChineseName, sortResultList, canPushNewEntry, Highlight, resetSelectedAll, getBookChapterVerseChineseName, getChapterChineseName, getBookChapterChineseName, getTabLabel,
    VERSION, TIMEZONE_LIST, COUNTRY_LIST, MAX_LENGTH_SEARCH_STRING, MAX_LENGTH_NOTE_CONTENT, MAX_LENGTH_NOTE_TITLE, SPACE, API_BASE_URL, MAX_LENGTH_NON_SEARCH_STRING1, MAX_LENGTH_NON_SEARCH_STRING2,
    homeContext, searchContext, noteContext,
} from '../Utilities/sharedHeader';

const Profile4Personal = forwardRef((props, ref) => {

    useImperativeHandle(ref, () => ({
        validateInputs,
    }));

    const { mode, userListItem } = props;

    const { Slider, Snackbar, styled, grey, Grid, Chip, Divider, Tab, Tabs, Box, Accordion, AccordionSummary, AccordionDetails, ListItemIcon, List, ListItem, ListItemText, TextField, IconButton, InputBase, Paper, Alert, Select, FormControl, FormControlLabel, FormLabel, FormGroup, MenuItem, Container, Typography, ButtonGroup, Button, Stack, Fab, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Radio, RadioGroup, AppBar, Toolbar, Table, TableContainer, TableBody, TableRow, TableCell, CardMedia, CardContent, CssBaseline, FormHelperText, Switch, Card, CheckIcon, ClearIcon, DeleteIcon, CloseIcon, ExpandMoreIcon, VisibilityOutlinedIcon, KeyboardArrowUpIcon, KeyboardDoubleArrowUpIcon, HistoryIcon, StickyNote2Icon, NoteAddIcon, SearchIcon, DescriptionIcon, EditDocumentIcon, ImportContactsIcon, WestIcon, EastIcon, HomeIcon, PersonIcon, LogoutIcon, PlagiarismIcon, DeviceThermostatIcon, FileCopyIcon, LocalOfferIcon, InfoIcon } = mui;
    const { setButtonTextDialog4, setButtonText, setDialogTitle, setBookReadLogToBeCleared, setCallerConfirmationDialog, setCaller4NoteBookmarkList, setNoteSearchString, setConfirmedNoteSearchString, setNoteSearchStringClearButton, setShowRemainingNoteSearch, setSearchCriteriaListItem2, setSearchResultVerseList2, setPageNumberNoteSearch, setVerseListItem2, setNoteSearchStringPlaceHolder, reset4NoteSearch, setTabVerseListNew, reset4SignIn, setTitleToBeDeleted, reset4ConfirmationDialog, reset4GoToTopButtonVisible, reset4NoteBookmarkList, reset4Dialog4, reset4NoteBookmarkVerseList, reset4ChipArray, reset4verseLabelArrows4Result, reset4Switch1, reset4Dialog2, reset4Search, reset4Verse, reset4Chapter, reset4Book, reset4Home, setGoToTopButtonVisible, setVerseListItem, setNonSearchString1PlaceHolder, setNonSearchString2PlaceHolder, setSearchStringPlaceHolder, setSearchString, setShowLeftArrowVerseSearch, setShowRightArrowVerseSearch, setShowfabContentVerseSearch, setShowLeftArrowNote, setShowRightArrowNote, setShowfabContentNote, setShowLeftArrowNoteSearch, setShowRightArrowNoteSearch, setShowfabContentNoteSearch, setSearchCriteriaListItem, setPageNumberVerseSearch, setOpenConfirmationDialog, setOpen3, setConfirmedTabNumber, setOpen2, setPageNumberNote, setDetails, setLengthIndicator4Details, setLengthIndicator4Title, setLoading, setHistoryList, setHistoryListItemSelected, setHistoryBookChapter, setNoteBookmarkList, setNoteBookmarkListBookChapterVerse, setConfirmedSearchString, setNonSearchString1, setNonSearchString2, setSearchStringClearButton, setNonSearchStringClearButton, setSearchScopeList, setSearchScopeListItemSelected, setChipData, setShowRemaining, setSearchResultVerseList, setSearchHttpPostData, setBookChapterList, setBookChapterListItemSelected, setOpen1, setBookListItemSelected, setSearchCriteria, setLoading4Home, setUserListItem, setVerseReadLogList4Book, setSearchTabNumber, setBookChapter, setBookList, setTitle, setTitleClearButton, setBook4Accordion1, setChapter4Accordion1, setVerse4Accordion1, setBookChapter2, setBookChapterList2, setVerseList4Accordion1, setNoteBookmarkVerseList, setNoteBookmarkListItemToBeDeleted, setNoteBookmarkListItemToBeChanged, setTab4AddChange, setViewArea, setCredential, setCircularProgressText, setEmailExisted, setUsernameExisted, setLastNameOverMaxLength, setFirstNameOverMaxLength, reset4Profile } = reducer;
    const { SignUpEmailSent, Profile4System, Profile4Personal, History, AddChangeNote, FullFormatVerse, Book, Stack1, NoteVerseList, Chapter, Dialog1, Dialog2, Dialog3, Dialog4, Tab1, Navbar, VerseSearch, Verse, NoteBookmarkList, NoteBookmarkListItem, VerseLabelArrows4Result, ConfirmationDialog, Accordion1, ChipArray, SearchResult, ForgotPassword, ClipLoader1, VerseLabelArrows, Switch1, Selection, Profile, UserListItem } = component;  
    const { postUserListItem, bookRead, deleteVerseReadLogList, getNoteBookmarkList3, deleteLogListItem, getToken, postLogListItem, postPutSearchCriteriaListItem, deleteVerseReadLogListItem, postPutVerseReadLogListItem, postHistoryListItem, getHasNoteVersesAll, getSearchResultVerseList, getSearchCriteriaListItem, postNoteBookmarkListItem, putNoteBookmarkListItem2, putNoteBookmarkListItem1, getNoteBookmarkList, getVerseReadLogList4Book, getSearchScopeList, getVerseList4Accordion1, getUserListItem, getVerseList, getBookList, getHistoryList, putUserListItem } = useShared();

    //const dispatch = useDispatch(); // dispatch(
    // const userListItemToBeChanged = useSelector((state) => state.profile.userListItemToBeChanged);
    // const userListItemToBeAdded = useSelector((state) => state.profile.userListItemToBeAdded);    

    const [lastName, setLastName] = useState(userListItem.LastName);
    const [lastNameError, setLastNameError] = useState(false);
    const [lastNameErrorMessage, setLastNameErrorMessage] = useState('');

    const [firstName, setFirstName] = useState(userListItem.FirstName);
    const [firstNameError, setFirstNameError] = useState(false);
    const [firstNameErrorMessage, setFirstNameErrorMessage] = useState('');

    const [yearOfBirth, setYearOfBirth] = useState(userListItem.YearOfBirth);
    const [yearOfBirthError, setYearOfBirthError] = useState(false);
    const [yearOfBirthErrorMessage, setYearOfBirthErrorMessage] = useState('');

    const [gender, setGender] = useState(userListItem.Gender);

    const [timeZoneId, setTimeZoneId] = useState(userListItem.TimeZoneID);
    const [timeZoneIdError, setTimeZoneIdError] = useState(false);
    const [timeZoneIdErrorMessage, setTimeZoneIdErrorMessage] = useState('');

    const [email, setEmail] = useState(userListItem.Email);
    const [emailError, setEmailError] = useState(false);
    const [emailErrorMessage, setEmailErrorMessage] = useState('');

    const [username, setUsername] = useState(userListItem.UserName);
    const [usernameError, setUsernameError] = useState(false);
    const [usernameErrorMessage, setUsernameErrorMessage] = useState('');

    const [password, setPassword] = useState(userListItem.Password);
    const [passwordError, setPasswordError] = useState(false);
    const [passwordErrorMessage, setPasswordErrorMessage] = useState('');

    const [passwordRetype, setPasswordRetype] = useState(userListItem.PasswordRetype);
    const [passwordRetypeError, setPasswordRetypeError] = useState(false);
    const [passwordRetypeErrorMessage, setPasswordRetypeErrorMessage] = useState('');    

    const checkUserListItemExistedByEmail = async (email) => {
        try {
            const httpPostData = {
                Email: email
            };
            const url = API_BASE_URL + 'api/UserListItem/ExistedByEmail/';
            const response = await axios.post(url, httpPostData);
            if (response.data === true) {
            return true;
            } else {
            return false;
            }
        } catch (error) {
            console.log(error);
        }
    }  

    const checkUserListItemExistedByUserName = async (username) => {
        try {
            const httpPostData = {
                UserName: username
            };
            const url = API_BASE_URL + 'api/UserListItem/ExistedByUserName/';
            const response = await axios.post(url, httpPostData);
            if (response.data === true) {
            return true;
            } else {
            return false;
            }
        } catch (error) {
            console.log(error);
        }
    } 

    // const setValue = (e) => {
    //     let name = e.target.name;
    //     let value = e.target.value;
    //     switch(mode) {
    //         case 'Put':
    //             const itemToBeChanged = {...userListItemToBeChanged, [name]: value}
    //             dispatch(setUserListItemToBeChanged(itemToBeChanged));
    //             break;
    //         case 'Post':
    //             const itemToBeAdded = {...userListItemToBeAdded, [name]: value}
    //             dispatch(setUserListItemToBeAdded(itemToBeAdded));
    //             break;
    //     }        
    // }

    const validateInputs = async () => {
        
        let isValid = true;

        if (!lastName || lastName.length === 0) {
            setLastNameError(true);
            setLastNameErrorMessage('需要輸入姓氏');
            isValid = false;
        } else {
            setLastNameError(false);
            setLastNameErrorMessage('');
        }

        if (!firstName || firstName.length === 0) {
            setFirstNameError(true);
            setFirstNameErrorMessage('需要輸入名字');
            isValid = false;
        } else {
            setFirstNameError(false);
            setFirstNameErrorMessage('');
        }

        if (!yearOfBirth || yearOfBirth === 0) {
            setYearOfBirthError(true);
            setYearOfBirthErrorMessage('需要選擇出生年份');
            isValid = false;
        } else {
            setYearOfBirthError(false);
            setYearOfBirthErrorMessage('');
        }

        if (!timeZoneId || timeZoneId === '00') {
            setTimeZoneIdError(true);
            setTimeZoneIdErrorMessage('需要選擇國家/地區');
            isValid = false;
        } else {
            setTimeZoneIdError(false);
            setTimeZoneIdErrorMessage('');
        }

        if (mode === 'Post') {

            let emailOK = /\S+@\S+\.\S+/.test(email);
            if (!email || email.length === 0) {
                setEmailError(true);
                setEmailErrorMessage('需要輸入電子郵件地址');
                isValid = false;
            } else if (!emailOK) {
                setEmailError(true);
                setEmailErrorMessage('需要輸入正確電子郵件地址');
                isValid = false;      
            } else {
                const emailExists = await checkUserListItemExistedByEmail(email); // Fetch asynchronously
                if (emailExists) {
                    setEmailError(true);
                    setEmailErrorMessage('電子郵件地址已被他人使用');
                    isValid = false;
                } else {
                    setEmailError(false);
                    setEmailErrorMessage('');
                }
            }

            let usernameOK = /^(?=.*[a-z])(?=.*\d)[a-z0-9]+$/.test(username);
            if (!username || username.length === 0) {
                setUsernameError(true);
                setUsernameErrorMessage('需要輸入帳戶名稱');
                isValid = false;
            } else if (!usernameOK) {
                setUsernameError(true);
                setUsernameErrorMessage('必須包括最少一個小寫字母和一個數字，不接受標點符號。');
                isValid = false; 
            } else {
                const usernameExists = await checkUserListItemExistedByUserName(username); // Fetch asynchronously
                if (usernameExists) {
                    setUsernameError(true);
                    setUsernameErrorMessage('帳戶名稱已被他人使用');
                    isValid = false;
                } else {
                    setUsernameError(false);
                    setUsernameErrorMessage('');
                }
            }

        }

        let passwordOK = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/.test(password);
        if (!password || password.length === 0) {
            if (mode === 'Post') {
                setPasswordError(true);
                setPasswordErrorMessage('需要輸入密碼');
                isValid = false;             
            }
        } else if (!passwordOK) {
            setPasswordError(true);
            setPasswordErrorMessage('密碼組合錯誤，請重新輸入');
            isValid = false;      
        } else {
            setPasswordError(false);
            setPasswordErrorMessage('');
            if (passwordRetype !== password) {
                setPasswordRetypeError(true);
                setPasswordRetypeErrorMessage('兩組密碼不符，請重新輸入');
                isValid = false;      
            } else {
                setPasswordRetypeError(false);
                setPasswordRetypeErrorMessage('');
            }   
        }  

        if (isValid) {
            const item = {
                FirstName: firstName,
                LastName: lastName,
                YearOfBirth: yearOfBirth,
                Gender: gender,
                TimeZoneID: timeZoneId,
                Email: email,
                UserName: username,
                Password: password
            }
            //profile4PersonalAddedChanged(item);
            return item;
        }
        else {
            return null;
        }
        //return isValid;

    };

    const YearOfBirthSelect = () => {

        const currentYear = new Date().getFullYear(); // Get the current year
        const yearOfBirthList = getYearOfBirthList(currentYear); // Get the list of years

        return (
            <div>
                <FormControl fullWidth>
                    <FormLabel>出生年份</FormLabel>
                    <Select
                        name='YearOfBirth'
                        //id="ageRange"
                        value={yearOfBirth}
                        onChange={handleOnChangeYearOfBirth}
                        sx={{
                            height: 40, // Sets the height of the TextField container
                            '& .MuiInputBase-root': {
                            height: '100%', // Ensures the input matches the container height
                            },
                        }}                                         
                    >
                        <MenuItem key={0} value={0}>請選擇</MenuItem>
                        {yearOfBirthList.map((yearOfBirthListItem) => (
                            <MenuItem key={yearOfBirthListItem} value={yearOfBirthListItem}>
                                {yearOfBirthListItem}
                            </MenuItem>
                        ))}   
                    </Select>   
                    {yearOfBirthError && (
                    <FormHelperText sx={{ color: 'error.main' }}>
                        {yearOfBirthErrorMessage}
                    </FormHelperText>
                    )}                            
                </FormControl>          
            </div>
        );

    };  

    const handleOnChangeLastName = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        if (value.length <= 10) {
            setLastName(value);
            setLastNameError(false);
            setLastNameErrorMessage('');
        } else {
            setLastNameError(true);
            setLastNameErrorMessage('最長 10 個字串');
        } 
    }

    const handleOnChangeFirstName = (e) => {
        let name = e.target.name;
        let value = e.target.value; 
        if (value.length <= 10) {
            setFirstName(value);           
            setFirstNameError(false);
            setFirstNameErrorMessage('');
        } else {
            setFirstNameError(true);
            setFirstNameErrorMessage('最長 10 個字串');
        }     
    }

    const handleOnChangeYearOfBirth = (e) => {
        //setValue(e);
        setYearOfBirth(e.target.value);
    }

    const handleOnChangeGender = (e) => {
        //setValue(e);      
        setGender(e.target.value);
    }

    const handleOnChangeTimeZoneId = (e) => {
        //setValue(e);     
        setTimeZoneId(e.target.value);
    }

    const handleOnChangeEmail = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        if (value.length <= 50) {
            // const item = {...userListItemToBeChanged, [name]: value}
            // dispatch(setUserListItemToBeChanged(item));
            setEmail(value);
            setEmailError(false);
            setEmailErrorMessage('');
        } else {
            setEmailError(true);
            setEmailErrorMessage('最長 50 個字串');
        }      
    }

    const handleOnChangeUsername = (e) => {
        let name = e.target.name;
        let value = e.target.value.toLowerCase();
        //dispatch(setUsername(value.toLowerCase()));
        if (value.length <= 50) {
            // const item = {...userListItemToBeChanged, [name]: value}
            // dispatch(setUserListItemToBeChanged(item));
            setUsername(value);
            setUsernameError(false);
            setUsernameErrorMessage('');
        } else {
            setUsernameError(true);
            setUsernameErrorMessage('最長 50 個字串');
        }          
    }

    const handleOnChangePassword = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        if (value.length <= 50) {
            // const item = {...userListItemToBeChanged, [name]: value}
            // dispatch(setUserListItemToBeChanged(item));
            setPassword(value);
            setPasswordError(false);
            setPasswordErrorMessage('');
        } else {
            setPasswordError(true);
            setPasswordErrorMessage('最長 50 個字串');
        }  
    }

    const handleOnChangePassworddRetype = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        if (value.length <= 50) {
            // const item = {...userListItemToBeChanged, [name]: value}
            // dispatch(setUserListItemToBeChanged(item));
            setPasswordRetype(value);
            setPasswordRetypeError(false);
            setPasswordRetypeErrorMessage('');
        } else {
            setPasswordRetypeError(true);
            setPasswordRetypeErrorMessage('最長 50 個字串');
        }  
    }

    useEffect(() => {
        // if (mode === 'Post') {
        //     setEmail('');
        //     setUsername('');            
        // }
        // setPassword('');
        // setPasswordRetype('');
    }, []);

    return (

        <div>        

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>

                {mode === 'Put' && <Divider>個人設定</Divider>}                

                <Grid container spacing={1}>

                    <Grid size={6}>
                        <FormControl fullWidth>
                            <FormLabel>姓氏</FormLabel>
                            <TextField
                                required
                                fullWidth                  
                                //autoComplete="lastname"
                                name='LastName'
                                //id="lastname"
                                error={lastNameError}
                                value={lastName}
                                onChange={handleOnChangeLastName}
                                sx={{
                                    height: 40, // Sets the height of the TextField container
                                    '& .MuiInputBase-root': {
                                    height: '100%', // Ensures the input matches the container height
                                    },
                                }} 
                            />
                            {lastNameError && (
                            <FormHelperText sx={{ color: 'error.main' }}>
                                {lastNameErrorMessage}
                            </FormHelperText>
                            )}                        
                        </FormControl>
                    </Grid>

                    <Grid size={6}>
                        <FormControl fullWidth>
                            <FormLabel>名字</FormLabel>
                            <TextField
                                required
                                fullWidth                  
                                //autoComplete="firstname"
                                name='FirstName'
                                //id="firstname"
                                error={firstNameError}
                                value={firstName}
                                onChange={handleOnChangeFirstName}
                                sx={{
                                    height: 40, // Sets the height of the TextField container
                                    '& .MuiInputBase-root': {
                                    height: '100%', // Ensures the input matches the container height
                                    },
                                }}                                         
                            />
                            {firstNameError && (
                            <FormHelperText sx={{ color: 'error.main' }}>
                                {firstNameErrorMessage}
                            </FormHelperText>
                            )}
                        </FormControl>  
                    </Grid>  

                    <Grid size={6}>
                        <FormControl>
                            <FormLabel>性別</FormLabel>
                            <RadioGroup
                                name='Gender'
                                row
                                value={gender}
                                //id='gender'
                                onChange={handleOnChangeGender}
                            >
                                <FormControlLabel value='M' control={<Radio />} label='男' />
                                <FormControlLabel value='F' control={<Radio />} label='女' />
                            </RadioGroup>
                        </FormControl>
                    </Grid>  

                    <Grid size={6}>
                        {YearOfBirthSelect()}
                    </Grid>

                    <Grid size={12}>
                        <FormControl fullWidth>
                            <FormLabel>國家/地區</FormLabel>
                            <Select
                                name='TimeZoneID'
                                //id='country'
                                value={timeZoneId || '00'}
                                onChange={handleOnChangeTimeZoneId}
                                sx={{
                                    height: 40, // Sets the height of the TextField container
                                    '& .MuiInputBase-root': {
                                    height: '100%', // Ensures the input matches the container height
                                    },
                                }}                                     
                            >
                                <MenuItem key={'00'} value={'00'}>請選擇</MenuItem>
                                {TIMEZONE_LIST.map((timezoneListItem) => (
                                    <MenuItem key={timezoneListItem.value} value={timezoneListItem.value}>
                                        {timezoneListItem.label}
                                    </MenuItem>
                                ))}
                            </Select>
                            {timeZoneIdError && (
                            <FormHelperText sx={{ color: 'error.main' }}>
                                {timeZoneIdErrorMessage}
                            </FormHelperText>
                            )}                         
                        </FormControl>
                    </Grid>  

                </Grid>

                <FormControl>
                    <FormLabel>電子郵件地址</FormLabel>
                    <TextField
                        disabled={mode === 'Put'}
                        //required
                        fullWidth
                        //autoComplete="email"
                        name='Email'
                        //id="email"
                        error={emailError}
                        value={email}
                        onChange={handleOnChangeEmail}
                        sx={{
                            height: 40, // Sets the height of the TextField container
                            '& .MuiInputBase-root': {
                            height: '100%', // Ensures the input matches the container height
                            },
                        }}                                 
                    />
                    {emailError && (
                    <FormHelperText sx={{ color: 'error.main' }}>
                        {emailErrorMessage}
                    </FormHelperText>
                    )}
                </FormControl>

                <FormControl>
                    <FormLabel>帳戶名稱</FormLabel>
                    <TextField
                        disabled={mode === 'Put'}
                        //required
                        fullWidth
                        //autoComplete="username"
                        name='UserName'
                        //id="username"
                        error={usernameError}
                        value={username}
                        onChange={handleOnChangeUsername}   
                        sx={{
                            height: 40, // Sets the height of the TextField container
                            '& .MuiInputBase-root': {
                            height: '100%', // Ensures the input matches the container height
                            },
                        }}                                 
                    />
                    {usernameError && (
                    <FormHelperText sx={{ color: 'error.main' }}>
                        {usernameErrorMessage}
                    </FormHelperText>
                    )}    
                </FormControl>                 
                
                <FormControl>
                    <FormLabel>{mode === 'Put' && '新'}密碼 (組合至少 8 個字元，包括大小寫字母、數字和符號)</FormLabel>
                    <TextField
                        required
                        fullWidth
                        //autoComplete="password"
                        name='Password'
                        //id="password"
                        type='password'
                        error={passwordError}
                        value={password}
                        onChange={handleOnChangePassword}    
                        sx={{
                            height: 40, // Sets the height of the TextField container
                            '& .MuiInputBase-root': {
                            height: '100%', // Ensures the input matches the container height
                            },
                        }}                                  
                    />
                    {passwordError && (
                    <FormHelperText sx={{ color: 'error.main' }}>
                        {passwordErrorMessage}
                    </FormHelperText>
                    )}           
                </FormControl>
                
                <FormControl>
                    <FormLabel>重新輸入密碼</FormLabel>
                    <TextField
                        required
                        fullWidth
                        //autoComplete="passwordRetype"
                        name='PasswordRetype'
                        //id="passwordRetype"
                        type='password'
                        error={passwordRetypeError}
                        value={passwordRetype}
                        onChange={handleOnChangePassworddRetype}    
                        sx={{
                            height: 40, // Sets the height of the TextField container
                            '& .MuiInputBase-root': {
                            height: '100%', // Ensures the input matches the container height
                            },
                        }}                                   
                    />
                    {passwordRetypeError && (
                    <FormHelperText sx={{ color: 'error.main' }}>
                        {passwordRetypeErrorMessage}
                    </FormHelperText>
                    )}           
                </FormControl>

            </Box>

            <ConfirmationDialog />
            
        </div>

    )

});

export default Profile4Personal;